<template>
  <div>
    <NuxtLayout name="base" :page="page">
      <LayoutContainer class="dbc-c-stage dbc-c-stage--medium-right">
        <LayoutBlock :class="'dbc-c-stage__medium-block'">
          <NuxtImg
            class="dbc-c-image dbc-c-image"
            :src="imagePath"
            :alt="$t('dbc-text-deeplink-landing-page')"
            :sizes="'s:700px m:800px l:100px xl:1200px'"
          />
        </LayoutBlock>
        <LayoutBlock
          :class="'dbc-block-background-white dbc-c-stage__text-block'"
        >
          <UtilityHeadline
            :class="`dbc-text-color-${headlineColor} dbc-c-stage__headline`"
            :text="
              client === 'flinkster'
                ? $t('dbc-text-deeplink-landing-page-flinkster')
                : $t('dbc-text-deeplink-landing-page')
            "
            :level="1"
          />
          <div class="dbc-c-stage-fs__apps">
            <UtilityAppsBadge
              v-for="app in computeAppsByOs"
              :key="app.id"
              :app="app"
            />
          </div>
        </LayoutBlock>
      </LayoutContainer>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const { t, setLocale } = useI18n()
const locale = route.params.locale as string
setLocale(locale)

const apps = inject('apps') as Ref<App[] | null>
const mobileOs = useMobileOs()

const computeAppsByOs = computed(() => {
  if (apps.value && mobileOs.value !== '') {
    return apps.value.filter((app) => app.os === mobileOs.value)
  }

  return apps.value
})

onMounted(() => {
  if (computeAppsByOs.value?.length === 1) {
    window.location.replace(computeAppsByOs.value[0]!.link)
  }
})

const client = useRuntimeConfig().public.client

const imagePath =
  client === 'flinkster'
    ? '/images/get-the-app-flinkster.png'
    : '/images/get-the-app.jpeg'

const headlineColor =
  client === 'cab' || client === 'flinkster' ? 'black' : 'primary'

const page: Page = {
  id: 0,
  title: t('dbc-text-get-the-app'),
  path: '/get-the-app',
  description: '',
  content: [],
  localizations: [
    {
      id: 0,
      title: 'Get the App',
      path: 'get-the-app',
      locale: 'de',
    },
    {
      id: 1,
      title: 'Get the App',
      path: 'get-the-app',
      locale: 'en',
    },
  ],
  locale: locale,
}

usePageHead(page)
</script>
